import React from "react";
import { Layout } from "../../components/Layout";
import { Breadcrumbs } from "../../components/Breadcrumbs";
import { PostTagForm } from "../../forms/PostTagForm";
import Typography from "@material-ui/core/Typography";
import { RouteChildrenProps } from "react-router";
import { Link } from "react-router-dom";
import { useDetail } from "../../useAPI";
import { PostTag } from "../../types/PostTag";
import { updateTag } from "../../actions/tag/updateTag";
import { deleteTag } from "../../actions/tag/deleteTag";

export function PostTagEdit(
  props: RouteChildrenProps<{
    postTagId: string;
  }>
) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const postTagId = props.match!.params.postTagId;
  const { data, error } = useDetail<PostTag>("post-tags", postTagId);

  return (
    <Layout>
      <Breadcrumbs>
        <Link to={"/post-tags"}>Post Tags</Link>
        <Typography color="textPrimary">
          {error ? error : data ? data.name : "Loading"}
        </Typography>
      </Breadcrumbs>
      {data && (
        <PostTagForm
          type="update"
          initialValues={data}
          onSubmit={async (values) => {
            await updateTag(postTagId, values);
          }}
          onDelete={async () => {
            await deleteTag(postTagId);
            props.history.push("/post-tags");
          }}
        />
      )}
    </Layout>
  );
}
